export default {
    'total-bonds': 'Número total de bonos',
    'file-state': 'Estado de archivo',
    'financial-file-fund': 'Cuenta de caja principal',
    'undefined': 'No asignado, por favor asigne uno',
    'not-posted': 'No arrastrado',
    'all-posted-bonds': 'Todos los bonos están arrastrados',
    'locked': 'Cerrado',
    'unlocked': 'No cerrado',
}